// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * you can see yup to define your custom rules as the following:
 *
 * yup way:
 * yup.string().email().min(5).max(200)
 *
 * our way:
 * string|email|min:5|max:200
 *
 *
 * you don't really need to pass string| because its default, but if you want it to
 * be number you should pass number in the series possible types is:
 *  ("mixed", "string", "number", "boolean", "date", "array", "object")
 *
 * to make it easier to write we define the rules as a string separated by pipes
 * any yup function, you only need to pass its name as email, if you want to
 * pass areguments to it you can say like max:5 instead of max(5).
 *
 * yup docs: https://github.com/jquense/yup
 *
 */

const xDefaultRules = {
    text: "max:100",
    password: "min:8|max:75",
    email: "email|min:5|max:125",
    phone: "phone",
    qty: "number|min:0|max:99999",
    companyName: "min:1|max:40",
    address: "min:1|max:50",
    city: "min:1|max:50",
    postalCodeUS: "postalCode:US|min:5|max:50",
    postalCodeCA: "postalCode:CA|max:50",
    poNumber: "max:50",
    releaseNumber: "max:50",
    notes: "max:500",
    fullName: "min:2|max:50",
    firstName: "min:2|max:30",
    lastName: "min:2|max:30",
    url: "url|max:2048",
    userName: "min:2|max:60",
    object: "object",
    number: "number",
    jobName: "max:50",
    date: "date",
};

const xMapTypeToDomType: { [key: string]: string } = {
    email: "email",
    password: "password",
};

export const maxQtyNumber = 99999;

export default xDefaultRules;

export { xDefaultRules, xMapTypeToDomType };
